// extracted by css-extract-rspack-plugin
module.exports =  {"nrljournal_banner":"Ez9E7","thin":"I8Id8","btn":"V7s88","know_more":"b2ftj"};